import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import appUrls from '../config/urls';
import { PairStatusModel } from '../data/models/pair-status-model';

@Injectable({
  providedIn: 'root'
})
export class HatterasService {

  url = appUrls.lineDetails;
  constructor(private http: HttpClient) { }

  getHatterasLines(ipAddress: string) {
    let obj = { name: ipAddress };
    return this.http.post < Map < number, PairStatusModel>>(this.url.getHatterasLineStatus, obj);
  }
}
